import { success, Uuid } from "@secretaa/http-contract";
import { z } from "zod";
import { Scope, Profile } from "./ai-model-control.ts";
import { PreparationDraftArtifact, PreparationArtifactRef } from "./work-os/preparation-artifact.ts";
import { Digest } from "./work-os/primitives.ts";
/** Consumer invocation selects an exact historical producer; owner resolves all authority. */
export const Command = z.object({ scope: Scope, profile: Profile, producerRunId: Uuid, artifactRef: PreparationArtifactRef, digest: Digest }).strict();
export type Command = z.infer<typeof Command>;
export const Result = z.object({ scope: Scope, profile: Profile, output: PreparationDraftArtifact }).strict();
export type Result = z.infer<typeof Result>;
export const Response = success(Result);
export const PATH = "/api/internal/v1/ai-preparation-artifacts";
export const CONTRACT_VERSION = "1.0.0";
